import React from 'react';
import ReactDOM from 'react-dom/client';

// Import ClientPortal directly — NOT through App.js.
// App.js imports the entire react-admin framework, all admin resources,
// Firebase data/auth providers, etc. None of that is needed for the client
// portal, and it massively inflates the bundle (often 2–3 MB of unused code).
import ClientPortal from './components/ClientPortal/ClientPortal';
import CofidisSignaturePage from './components/ClientPortal/CofidisSignaturePage';

// Determine which component to render based on URL parameters
const urlParams = new URLSearchParams(window.location.search);
const action = urlParams.get('action');

const isMortgagePortal = window.location.hostname === 'solicitud-hipoteca.easydebt.es'
  || window.location.hostname === 'solicitud-hipoteca.web.app';

// Set the document title
document.title = action === 'sign'
  ? 'EasyDebt | Firma de Autorización'
  : isMortgagePortal
    ? 'EasyDebt | Solicitud de Hipoteca'
    : 'EasyDebt | Registro Seguro';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {action === 'sign' ? <CofidisSignaturePage /> : <ClientPortal mortgageMode={isMortgagePortal} />}
  </React.StrictMode>
);
